module.exports = __webpack_public_path__ + "img/shipo-sales-plan-no-data.58173d39.svg";